angular.module('bizmetryApp').controller('UserProfileDialogController', function (
    $scope,
    $mdDialog,
    $location,
    AuthService,
    UserProfileService,
    currentUser,
    dialogService,
    $mdToast
) {
    console.log('🔵 UserProfileDialogController initialized');

    $scope.loading = true;
    $scope.user = {};

    // ── Load profile from backend ─────────────────────────────────────────────
    UserProfileService.getUserProfile()
        .then(function (response) {
            var profile = response.data;
            var u = profile.user || {};
            var a = profile.account || {};

            $scope.user = {
                // ── User fields ─────────────────────────────────
                userId: u.id,
                email: u.email,
                firstName: u.firstName,
                lastName: u.lastName,
                isSuperUser: u.isSuperUser,
                userEnabled: u.userEnabled,
                isConfirmed: u.isConfirmed,
                lastLogin: u.lastLogin,
                createdTs: u.createdTs,
                user2FANumber: u.user2FANumber,
                trustedIps: u.trustedIps || [],
                roles: u.userRoles || [],
                keyCloakId: u.keyCloakId,

                // ── Account fields ───────────────────────────────
                id: a.id,               // org id (used for copyOrgId)
                orgName: a.organization,
                accountType: a.accountTypeLabel,
                accountTypeId: a.accountTypeId,
                countryId: a.countryId,
                countryLabel: a.countryLabel,
                stateId: a.stateId,
                stateLabel: a.stateLabel,
                isActive: a.isActive
            };

            console.log('✅ User profile loaded:', $scope.user);
        })
        .catch(function (error) {
            console.error('❌ Failed to load user profile:', error);
            // Fallback to injected currentUser so the dialog doesn't show empty
            $scope.user = angular.copy(currentUser || {});
            dialogService.showErrorDialog(
                'Profile Load Error',
                'Could not load your profile. Showing cached data.'
            );
        })
        .finally(function () {
            $scope.loading = false;
        });

    // ── Helpers ───────────────────────────────────────────────────────────────

    $scope.isSuperUser = function () {
        return $scope.user.isSuperUser === true;
    };

    $scope.closeDialog = function () {
        $mdDialog.hide();
    };

    $scope.getAccountTypeColor = function (accountTypeName) {
        if (!accountTypeName) return '#757575';
        const hash = accountTypeName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const palette = ['#1976d2', '#d32f2f', '#388e3c', '#f57c00', '#7b1fa2', '#0097a7'];
        return palette[hash % palette.length];
    };

    // ── Edit profile ──────────────────────────────────────────────────────────

    $scope.changePassword = function () {
        $mdDialog.show({
            controller: 'EditProfileDialogController',
            templateUrl: '/home/user-profile/edit-profile-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: false,
            multiple: true,
            locals: {
                currentUser: $scope.user
            }
        })
            .then(function (result) {
                if (!result) return;
                if (typeof result.firstName !== 'undefined') $scope.user.firstName = result.firstName;
                if (typeof result.lastName !== 'undefined') $scope.user.lastName = result.lastName;
                if (typeof result.user2FANumber !== 'undefined') $scope.user.user2FANumber = result.user2FANumber;
            })
            .catch(function () {
                console.log('🚫 Edit profile dialog cancelled');
            });
    };

    // ── Edit organization ─────────────────────────────────────────────────────

    $scope.editOrganization = function () {
        $mdDialog.show({
            controller: 'EditOrganizationDialogController',
            templateUrl: '/home/user-profile/edit-organization/edit-organization-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: true,
            multiple: true,
            locals: {
                accountId: $scope.user.id
                // currentData eliminado — el dialog consulta el backend directamente
            }
        }).then(function (updatedData) {
            if (!updatedData) return;

            $scope.user.orgName = updatedData.organizationName;
            $scope.user.accountTypeId = updatedData.accountTypeId;
            $scope.user.accountType = updatedData.accountTypeName;
            $scope.user.countryId = updatedData.countryId;
            $scope.user.countryLabel = updatedData.countryName;
            $scope.user.stateId = updatedData.stateId;
            $scope.user.stateLabel = updatedData.stateName;

            // Keep sessionStorage in sync
            try {
                var stored = JSON.parse(sessionStorage.getItem('user'));
                if (stored) {
                    stored.orgName = updatedData.organizationName;
                    stored.accountTypeId = updatedData.accountTypeId;
                    stored.accountType = updatedData.accountTypeName;
                    stored.countryId = updatedData.countryId;
                    stored.countryLabel = updatedData.countryName;
                    stored.stateId = updatedData.stateId;
                    stored.stateLabel = updatedData.stateName;
                    sessionStorage.setItem('user', JSON.stringify(stored));
                }
            } catch (e) {
                console.warn('⚠️ Failed to update sessionStorage:', e);
            }
        }).catch(function () {
            console.log('ℹ️ Edit organization dialog was cancelled');
        });
    };

    // ── Logout ────────────────────────────────────────────────────────────────

    $scope.logout = function () {
        dialogService.showDecisionDialog('Logout Confirmation', 'Are you sure you want to terminate the session?')
            .then(function (decision) {
                if (decision === 'proceed') {
                    AuthService.logout()
                        .then(function () {
                            $mdDialog.hide();
                            $location.path('/login');
                        })
                        .catch(function (error) {
                            console.error('❌ Logout failed:', error);
                            dialogService.showErrorDialog('Logout Error', 'An error occurred while logging out.');
                        });
                }
            });
    };

    // ── Copy org ID ───────────────────────────────────────────────────────────

    $scope.copyOrgId = function () {
        var orgId = $scope.user.id;
        if (!orgId) { dialogService.showErrorDialog('Error', 'Organization ID not available.'); return; }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(orgId)
                .then(function () {
                    $mdToast.show($mdToast.simple()
                        .textContent('Organization ID copied to clipboard')
                        .position('top right').hideDelay(3000));
                })
                .catch(function () {
                    dialogService.showErrorDialog('Copy Failed', 'Failed to copy ID to clipboard.');
                });
        } else {
            var el = document.createElement('textarea');
            el.value = orgId;
            el.style.position = 'fixed';
            el.style.left = '-999999px';
            document.body.appendChild(el);
            el.select();
            try {
                document.execCommand('copy');
                $mdToast.show($mdToast.simple()
                    .textContent('Organization ID copied to clipboard')
                    .position('top right').hideDelay(3000));
            } catch (e) {
                dialogService.showErrorDialog('Copy Failed', 'Failed to copy ID to clipboard.');
            }
            document.body.removeChild(el);
        }
    };
});